/*
* Main nav dropdowns (`.nav-item.dropdown` under the market/footer-nav menus
* in nav.html) open on hover instead of click at the `lg` breakpoint and up.
* Below `lg` (mobile/tablet, no mouse to hover with) Bootstrap's native
* click-to-toggle behavior is left untouched.
*/
import * as bootstrap from "bootstrap";

// Matches the $grid-breakpoints "lg" value in src/css/_vars.scss.
const desktop_query = window.matchMedia("(min-width: 992px)")

window.addEventListener("load", () => {
    document.querySelectorAll(".navbar .nav-item.dropdown").forEach((item) => {
        const toggle = item.querySelector(".dropdown-toggle")
        if (!toggle) {
            return
        }
        const dropdown = bootstrap.Dropdown.getOrCreateInstance(toggle)

        item.addEventListener("mouseenter", () => {
            if (desktop_query.matches) {
                dropdown.show()
            }
        })
        item.addEventListener("mouseleave", () => {
            if (desktop_query.matches) {
                dropdown.hide()
            }
        })
    })
})
